<switch-account-type
  [activeAccountType]="activeAccountType$ | async"
  [tabs]="tabs$ | async"
  (confirm)="onConfirm($event)"
></switch-account-type>
